// extracted by mini-css-extract-plugin
module.exports = {"blockCommon":"page-header__blockCommon___3JrCu","Header":"page-header__Header___2cLYj"};